import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import SDK from "./sdk";
import "../app/variables.css";
import "../app/root.scss";
import "./sdk.css";
export function initSDKRoot(config) {
    var rootEl = document.createElement("div");
    rootEl.id = "__travel-sdk__root";
    document.body.appendChild(rootEl);
    var root = createRoot(rootEl);
    root.render(_jsx(SDK, { config: config }));
}
